module.exports = __webpack_public_path__ + "components/rewards/dragon-lodge/static/logo-53fef0f9b63f9a45df38a52a6eb93c45.jpg";